import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-vbaintro',
  templateUrl: './page-vbaintro.component.html',
  styleUrls: ['./page-vbaintro.component.scss']
})
export class PageVBAintroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
